export const BASE_API_URL =

process.env.NODE_ENV === 'production'
? 'https://dontdiewithout.herokuapp.com'
: 'http://localhost:5005'